const EndUser = {
  EN: {
    header: 'End user',
    search: {
      searchWith: 'Search user with',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      sync: 'Sync status',
      role: 'Role',
      group: 'Group',
    },
    placeholder: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      sync: 'Sync status',
      role: 'Role',
      group: 'Group',
    },
    button: {
      manageTable: 'Manage table',
      manageUsers: 'Manage users',
      sync: 'Sync',
      remove: 'Remove',
      invite: 'Invite',
      member: 'Add member',
      restore: 'Restore default columns',
    },
    menu: {
      1: 'Setting',
      2: 'Password',
      3: 'Passcode',
      4: 'Face ID',
      5: 'Card',
      6: 'License-plate',
      7: 'Link Line',
    },
    editUser: {
      title: {
        password: 'Password',
        passcode: 'Passcode',
        faceId: 'Face ID',
        card: 'Card',
        plate: 'License-plate',
        linkLine: 'Link line QR-code',
      },
      subtitle: {
        password: 'Change your account password',
        passcode: 'Change your account passcode',
        faceId: 'Change your face ID',
        card: 'Manage your card',
        plate: 'Manage your license-plate',
        linkLine: 'display link line qrcode',
        descriptionQR: 'the QR code will expire after one day',
        modal1: 'This user already has a QR code for the link line.',
        modal2: ' Do you want to generate new QR code?',
      },
      textField: {
        setting: {
          firstName: 'First name',
          lastName: 'Last name',
          profile: 'Profile name',
          email: 'Email',
          role: 'Role',
          group: 'Group',
          update: 'update',
        },
        password: {
          newPassword: 'New password',
          confirmPassword: 'Confirm new password',
        },
        passcode: {
          newPasscode: 'New passcode',
          confirmPasscode: 'Confirm new passcode',
        },
        card: {
          id: 'CARD ID:',
          title: 'CARD TITLE:',
          addButton: 'ADD',
          editButton: 'EDIT',
          deleteButton: 'DELETE',
        },
        plate: {
          title: 'PLATE NUMBER:',
          addButton: 'ADD',
          editButton: 'EDIT',
          deleteButton: 'DELETE',
        },
      },
      modal: {
        card: {
          editCard: 'Confirm edit card',
          statusActive: 'Do you want to activate card?',
          statusInactive: 'Do you want to inactivate card?',
        },
        plate: {
          editCard: 'Confirm edit license-plate',
          statusActive: 'Do you want to activate license-plate?',
          statusInactive: 'Do you want to inactivate license-plate?',
        },
      },
      swal: {
        card: {
          title: 'Card Limit Exceeded',
          text: 'Sorry, you cannot have more than 5 cards per user',
        },
        plate: {
          title: 'plate Limit Exceeded',
          text: 'Sorry, you cannot have more than 5 cards per user',
        },
      },
    },
    modal: {
      syncTitle: 'Do you want to sync?',
      removeTitle: 'Do you want to remove?',
      inviteTitle: {
        title: 'Invite user',
        email: 'Email*',
        role: 'Role*',
        group: 'Group (optional)',
        confirm: {
          title: 'Do you want to invite?',
          email: 'Email : ',
          role: 'Role : ',
          group: 'Group : ',
        },
        helperText: {
          email: 'Email should not be empty.',
          role: 'Role should not be empty.',
        },
      },
      manageUsers: {
        title: 'Manage users',
        role: 'Role*',
        group: 'Group (optional)',
        helperText: {
          emptyUsers: 'User not found',
          users: 'Please select user',
          role: 'Role should not be empty.',
        },
      },
      otp: {
        verify: 'Verify OTP Email',
        reqButton: 'Request OTP',
      },
      memberTitle: {
        title: 'Add member',
        firstName: 'First Name*',
        lastName: 'Last Name*',
        email: 'Email (optional)',
        role: 'Role*',
        group: 'Group (optional)',
        confirm: {
          title: 'Do you want to add member?',
          name: 'Full Name : ',
          email: 'Email :',
          role: 'Role : ',
          group: 'Group : ',
        },
        helperText: {
          firstName: 'First name should not be empty.',
          lastName: 'Last name should not be empty.',
          role: 'Role should not be empty.',
        },
      },
    },
    manageTable: {
      title: 'Manage columns',
      subTitle: 'Select column will appear in table',
      default: 'Default columns',
    },
    swal: {
      sync: {
        title: 'Device not found',
        message: 'Please check your device in project',
      },
    },
  },
  TH: {
    header: 'ผู้ใช้งาน',
    search: {
      searchWith: 'ค้นหาผู้ใช้งานด้วย',
      firstName: 'ชื่อ',
      lastName: 'นามสกุล',
      email: 'อีเมล',
      phone: 'โทรศัพท์',
      status: 'สถานะ',
      sync: 'การซิงค์',
      role: 'บทบาท',
      group: 'กลุ่ม',
    },
    placeholder: {
      firstName: 'ชื่อ',
      lastName: 'นามสกุล',
      email: 'อีเมล',
      phone: 'โทรศัพท์',
      status: 'สถานะ',
      sync: 'การซิงค์',
      role: 'บทบาท',
      group: 'กลุ่ม',
    },
    button: {
      manageTable: 'จัดการตาราง',
      manageUsers: 'จัดการผู้ใช้งาน',
      sync: 'ซิงค์',
      remove: 'ลบ',
      invite: 'เชิญผู้ใช้',
      member: 'เพิ่มสมาชิก',
      restore: 'คืนค่าเริ่มต้น',
    },
    menu: {
      1: 'ข้อมูลผู้ใช้งาน',
      2: 'รหัสผ่านผู้ใช้งาน',
      3: 'รหัสผ่าน 6 หลัก',
      4: 'ใบหน้า',
      5: 'บัตร',
      6: 'ทะเบียนรถ',
      7: 'ลิงค์ไลน์',
    },
    editUser: {
      title: {
        password: 'รหัสผ่านผู้ใช้งาน',
        passcode: 'รหัสผ่าน 6 หลัก',
        faceId: 'ใบหน้า',
        card: 'บัตร',
        plate: 'ทะเบียนรถ',
        linkLine: 'คิวอาร์โค้ด',
      },
      subtitle: {
        password: 'เปลี่ยนรหัสผ่านผู้ใช้งาน',
        passcode: 'เปลี่ยนรหัสผ่าน 6 หลัก',
        faceId: 'เปลี่ยนใบหน้า',
        card: 'จัดการการ์ด',
        plate: 'จัดการทะเบียนรถ',
        linkLine: 'คิวอาร์โค้ดสำหรับไลน์',
        descriptionQR: 'คิวอาร์โค้ดจะอยู่ได้ 1 วัน',
        modal1: 'ผู้ใช้งานคนนี้มีคิวอาร์โค้ดอยู่ในระบบแล้ว',
        modal2: 'กดยืนยันเพื่อสร้างใหม่',
      },
      textField: {
        setting: {
          firstName: 'ชื่อ',
          lastName: 'นามสกุล',
          profile: 'ชื่อโปรไฟล์',
          email: 'อีเมล',
          role: 'บทบาท',
          group: 'กลุ่ม',
          update: 'เปลี่ยน',
        },
        password: {
          newPassword: 'รหัสผ่านใหม่',
          confirmPassword: 'ยืนยันรหัสผ่านใหม่',
        },
        passcode: {
          newPasscode: 'รหัส 6 หลักใหม่',
          confirmPasscode: 'ยืนยันรหัส 6 หลักใหม่',
        },
        card: {
          id: 'เลขบัตร:',
          title: 'ชื่อบัตร',
          addButton: 'เพิ่ม',
          editButton: 'แก้ไข',
          deleteButton: 'ลบ',
        },
        plate: {
          title: 'เลขทะเบียนรถ:',
          addButton: 'เพิ่ม',
          editButton: 'แก้ไข',
          deleteButton: 'ลบ',
        },
      },
      modal: {
        card: {
          editCard: 'ยืนยันการแก้ไขการ์ด',
          statusActive: 'ต้องการที่จะเปิดการใช้งานการ์ดใช่หรือไม่',
          statusInactive: 'ต้องการที่จะปิดการใช้งานการ์ดใช่หรือไม่',
        },
        plate: {
          editCard: 'ยืนยันการแก้ไขทะเบียนรถ',
          statusActive: 'ต้องการที่จะเปิดการใช้งานทะเบียนรถใช่หรือไม่',
          statusInactive: 'ต้องการที่จะปิดการใช้งานทะเบียนรถใช่หรือไม่',
        },
      },
      swal: {
        card: {
          title: 'จำกัดจำนวนทะเบียนรถ',
          text: 'ขออภัย คุณไม่สามารถมีทะเบียนรถเกิน 5 ใบต่อผู้ใช้',
        },
      },
    },
    modal: {
      syncTitle: 'คุณต้องการที่จะซิงค์ผู้ใช้งานใช่หรือไม่',
      removeTitle: 'คุณต้องการที่จะลบผู้ใช้งานใช่หรือไม่',
      inviteTitle: {
        title: 'การเชิญผู้ใช้งาน',
        email: 'อีเมล*',
        role: 'บทบาท*',
        group: 'กลุ่ม (ตัวเลือก)',
        confirm: {
          title: 'ต้องการที่จะเชิญผู้ใช้งานใช่หรือไม่',
          email: 'อีเมล : ',
          role: 'บทบาท : ',
          group: 'กลุ่ม : ',
        },
        helperText: {
          email: 'อีเมลไม่ควรว่างเปล่า',
          role: 'บทบาทไม่ควรว่างเปล่า',
        },
      },
      manageUsers: {
        title: 'การจัดการผู้ใช้งาน',
        role: 'บทบาท*',
        group: 'กลุ่ม (ตัวเลือก)',
        helperText: {
          users: 'กรุณาเลือกผู้ใช้งาน',
          role: 'บทบาทไม่ควรว่างเปล่า',
        },
      },
      otp: {
        verify: 'ตรวจสอบอีเมล',
        reqButton: 'ขอรหัส OTP',
      },
      memberTitle: {
        title: 'เพิ่มสมาชิก',
        firstName: 'ชื่อ*',
        lastName: 'นามสกุล*',
        email: 'อีเมล (ตัวเลือก)',
        role: 'บทบาท*',
        group: 'กลุ่ม (ตัวเลือก)',
        confirm: {
          title: 'ต้องการที่จะเพิ่มสมาชิกใช่หรือไม่',
          name: 'ชื่อ-นามสกุล : ',
          email: 'อีเมล :',
          role: 'บทบาท : ',
          group: 'กลุ่ม : ',
        },
        helperText: {
          firstName: 'ชื่อไม่ควรว่างเปล่า',
          lastName: 'นามสกุลไม่ควรว่างเปล่า',
          role: 'บทบาทไม่ควรว่างเปล่า',
        },
      },
    },
    manageTable: {
      title: 'การจัดการคอลัมน์',
      subTitle: 'ข้อมูลจะถูกนำไปใช้ในตาราง',
      default: 'ค่าเริ่มต้น',
    },
    swal: {
      sync: {
        title: 'ไม่พบอุปกรณ์',
        message: 'กรุณาตรวจสอบอุปกรณ์แล้วลองใหม่อีกครั้ง',
      },
    },
  },
};

export default EndUser;
